// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"7c28f6af","457":"c07ed7ae","488":"db012ca1","551":"9f29e59b","593":"6c937a65","646":"2ba79b40","828":"b8e24ebb","842":"77e7bf61"}[chunkId] + ".chunk.js";
};